import {React, Component, classnames} from '../../component';
import Indicator from '../../Indicator';
import ModalAlert from '../../ModalAlert';
import {CursorInput} from '../../Form';
import Api from '../../../api';


class MapResultEditor extends Component {

  renderLoaded({gameData, index}) {
    return (
      <div className='MapResultEditor'>
        <div className='MapResultEditor-Map'>{gameData.getIn(['maps', index, 'title'])}</div>
        <div className='MapResultEditor-Results'>
          <CursorInput maxLength='2' className='MapResultEditor-Score'
                       value={gameData.cursor(['claimed_results', index, 'team_a_score'])} />
          <div className='MapResultEditor-Dash'>&mdash;</div>
          <CursorInput maxLength='2' className='MapResultEditor-Score'
                       value={gameData.cursor(['claimed_results', index, 'team_b_score'])} />
        </div>
      </div>
    );
  }
}


export default class ClaimResultsPopup extends ModalAlert {

  static defaultProps = {
    action: 'Отправить'
  }

  async onAction() {
    const results = [];
    const {gameData} = this.props;
    let valid = true;

    gameData.get('maps').forEach(function(map, idx) {
      const claimedResult = gameData.getIn(['claimed_results', idx]);
      if (!claimedResult || !claimedResult.get('team_a_score') || !claimedResult.get('team_b_score')) {
        valid = false;
      } else {
        results.push({...claimedResult.toJS(), map_id: map.get('id')})
      }
    });

    if (valid) {
      this.setState({
        progress: true
      });
      await Api.gameClaimResults(gameData.get('id'), results);
      this.close();
    }
  }

  renderActionButton() {
    const actionClassName = classnames(
      'ModalAlert-Action',
      {
        'ModalAlert-Action--Progress': this.state.progress
      }
    );
    return (
      <div className={actionClassName} onClick={this.onAction.bind(this)} style={{marginTop: 23}}>
        {this.state.progress && <Indicator className='ModalAlert-Indicator' />}
        Отправить
      </div>
    );
  }

  renderMessage() {
    const {gameData} = this.props;
    return (
      <div className='ClaimResultsPopup'>
        <div className='ClaimResultsPopup-Title'>Матч завершен</div>
        <div className='ClaimResultsPopup-Subtitle'>Указанные результаты будут отправлены судье матча.</div>
        <div className='ClaimResultsPopup-Separator' />
        <div className='ClaimResultsPopup-Results'>
          <div className='ClaimResultsPopup-Teams'>
            <div className='ClaimResultsPopup-TeamName'>{gameData.getIn(['team_a', 'title'])}</div>
            <div className='ClaimResultsPopup-TeamName'>{gameData.getIn(['team_b', 'title'])}</div>
          </div>
          {gameData.get('maps').map((map, index) =>
            <MapResultEditor gameData={gameData} key={index} index={index} />
          )}
        </div>
        <div className='ClaimResultsPopup-Separator ClaimResultsPopup-Separator--bottom' />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/GameDetails/ClaimResultsPopup.js